/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { WarningTriangleIcon16Light } from './WarningTriangleIcon16Light';
import { WarningTriangleIcon16Regular } from './WarningTriangleIcon16Regular';
import { WarningTriangleIcon16Solid } from './WarningTriangleIcon16Solid';
import { WarningTriangleIcon20Light } from './WarningTriangleIcon20Light';
import { WarningTriangleIcon20Regular } from './WarningTriangleIcon20Regular';
import { WarningTriangleIcon20Solid } from './WarningTriangleIcon20Solid';
import { WarningTriangleIcon24Regular } from './WarningTriangleIcon24Regular';
import { WarningTriangleIcon24Solid } from './WarningTriangleIcon24Solid';
import { WarningTriangleIcon32Regular } from './WarningTriangleIcon32Regular';
import { WarningTriangleIcon64Regular } from './WarningTriangleIcon64Regular';
var sizes = {
    16: {
        light: WarningTriangleIcon16Light,
        regular: WarningTriangleIcon16Regular,
        solid: WarningTriangleIcon16Solid,
    },
    20: {
        light: WarningTriangleIcon20Light,
        regular: WarningTriangleIcon20Regular,
        solid: WarningTriangleIcon20Solid,
    },
    24: {
        regular: WarningTriangleIcon24Regular,
        solid: WarningTriangleIcon24Solid,
    },
    32: {
        regular: WarningTriangleIcon32Regular,
    },
    64: {
        regular: WarningTriangleIcon64Regular,
    },
};
export var WarningTriangleIcon = forwardRef('WarningTriangleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
